[
  {
    "code": "AU-ACT",
    "name": "Australian Capital Territory"
  },
  {
    "code": "AU-NSW",
    "name": "New South Wales"
  },
  {
    "code": "AU-NT",
    "name": "Northern Territory"
  },
  {
    "code": "AU-QLD",
    "name": "Queensland"
  },
  {
    "code": "AU-SA",
    "name": "South Australia"
  },
  {
    "code": "AU-TAS",
    "name": "Tasmania"
  },
  {
    "code": "AU-VIC",
    "name": "Victoria"
  },
  {
    "code": "AU-WA",
    "name": "Western Australia"
  }
]